// eslint-disable-next-line no-restricted-imports
import { IconButtonStyles } from './IconButton.styles';
import { IconButtonProps } from './types';

/**
 * IconButton component.
 */
export const IconButton = ({ icon, ...props }: IconButtonProps) => (
  <IconButtonStyles {...props} startIcon={icon} />
);
